import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
// import { Mutations } from "@/store/enums/StoreEnums";
import DocMenuConfig from "@/core/config/MainMenuConfig";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "nav",
    redirect: "/dashboard",
    component: () => import("@/layouts/main-layout/MainLayout.vue"),
    meta: {
      middleware: "auth",
    },
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
        meta: {
          pageTitle: "Dashboard",
          breadcrumbs: ["Dashboard"],
        },
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/layouts/SystemLayout.vue"),
  },
  {
    path: "/",
    //component: () => import("@/components/page-layouts/Auth.vue"),
    component: () => import("@/layouts/AuthLayout.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
        meta: {
          pageTitle: "Entrar",
        },
      },
      {
        path: "/sign-up",
        name: "sign-up",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignUp.vue"),
      },
      {
        path: "/password-reset",
        name: "password-reset",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/PasswordReset.vue"),
      },
      {
        path: "/register",
        name: "register",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/Register.vue"),
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/components/page-layouts/Market.vue"),
    children: [
      {
        path: "/market",
        name: "market",
        component: () => import("@/views/market/Market.vue"),
        children: [
          {
            path: "/market/produto/:loja/:id",
            name: "/market/produto/:loja/:id",
            component: () => import("@/views/market/Produto.vue"),
          },
        ],
      },
    ],
  },
  // {
  //   // the 404 route, when none of the above matches
  //   path: "/404",
  //   name: "404",
  //   component: () => import("@/views/crafted/authentication/Error404.vue"),
  // },
  // {
  //   path: "/:pathMatch(.*)*",
  //   redirect: "/404",
  // },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  // reset config to initial state
  //store.commit(Mutations.RESET_LAYOUT_CONFIG);
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);

  //Carregar usuarios
  //const user = JSON.parse(localStorage.getItem("user") || "{}");
  const user = localStorage.getItem("user");

  if (DocMenuConfig.length === 1 && user != null) {
    const userp = JSON.parse(user || "{}");
    store.dispatch("menu/montarMenu", userp);
    next(to.fullPath);
  } else {
    next();
  }
});

export default router;
